module.exports = __webpack_public_path__ + "img/logo.a2a668ea.png";